const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_AUTHORS_LIST",
  FETCH_LIST_REQUEST: "FETCH_AUTHORS_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_AUTHORS_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_AUTHORS_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_AUTHORS_LIST",
}

export default LIST_ACTION_TYPES
